const phone=document.querySelector('.footer__nav__list .p-sides:first-child .footer__nav .nav__item:nth-child(2) a');
const email=document.querySelector('.footer__nav__list .p-sides:first-child .footer__nav .nav__item:nth-child(3) a');

phone.setAttribute('href', `tel:${phone.textContent}`);
email.setAttribute('href', `mailto:${email.textContent}`);

const w = window.innerWidth;

if(w < 1025 ) {
    const aboutCol = document.querySelector('.footer__nav__list .p-sides:first-child');
    const footerFirstRow = document.querySelector('footer > .rw .clm:nth-child(2)');

    footerFirstRow.appendChild(aboutCol);
}
 